import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const TICKET_AUTOMATION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomation/";

export const listAutomations = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(TICKET_AUTOMATION_ROUTE + "list", {
    params: params,
    paramsSerializer: { indexes: null },
  });
};
